import { Box, useTheme } from "@mui/material";

import {
	EnhancedRadioGroupRHFWithLabel,
} from "@websential/cosmic-v20";
import { EnhancedRadioGroupRHFWithLabelAndDescription } from "./EnhancedRadioGroupRHFWithLabelAndDescription";
import { FC } from "react";

interface INewAcocuntPaymentSetupPanel {
	formMethods: any
}
export const NewAcocuntPaymentSetupPanel: FC<
	INewAcocuntPaymentSetupPanel
> = ({
	formMethods
}) => {
		const theme = useTheme();
		const onPaymentSetupChangeHandler = (e: any) => {
			let value = e.target.vlaue
			if (value !== "200") {
				formMethods.clearErrors(["accountNo", "branchTransitNumber", "bankFinancialNo"])
			}
		}
		return (
			<Box sx={{ "& .MuiTypography-root": { fontSize: ".875rem" } }}>
				<Box>
					<EnhancedRadioGroupRHFWithLabelAndDescription
						label=""
						name="paymentSetup"
						selectedValue={200}
						key="paymentSetup"
						testId="paymentSetup"
						options={[
							{
								label: `Pre Authorized Debit`,
								value: 200,
								description: "Bank verified PAD required. Direct deposit and taxes management available",
							},
							{
								label: `Wire Transfer`,
								value: 300,
								description: "No activation docs required. Direct deposit and taxes management available as funds pushed-wired, e-transfer, etc",
							},
							{
								label: `Credit Card`,
								value: 100,
								description: "No activation docs required. Only Payroll software available",
							}
						]}
						displayAsRow={false}
						onChangeHandler={onPaymentSetupChangeHandler}
					/>
				</Box>
			</Box>
		);
	};
